export default class ArtikelVideo {

  initForNode(videoNode) {
    videoNode.addEventListener("playing", event => this.onPlayVideoClicked(event.target));
  }

  onPlayVideoClicked(videoPlayer) {
    videoPlayer.classList.remove("content-video__video-player--cover");
  }
}

